import { memo } from "react";
function RouteOnCard(props) {
  return (
    <svg
      width="14"
      height="100%"
      viewBox="0 0 14 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.5 23V16.5H13.5V9.5H3.5V5.5"
        stroke={props.color}
        strokeLinejoin="round"
        strokeWidth={2}
      />
      <rect
        x="0.5"
        y="0.2"
        width="6"
        height="6"
        rx="3"
        fill={props.color}
        stroke="white"
      />
    </svg>
  );
}

export default memo(RouteOnCard);
